import * as turf from '@turf/turf';
import polylabel from 'polylabel';
import bearing from '@turf/bearing';
import { point } from '@turf/helpers';

function getBearing(start, end) {
    const a = point(start);  // [lng, lat]
    const b = point(end);

// Get the bearing in degrees
    const angle = bearing(a, b);
    return (angle + 360) % 360;

}

function replacePlaceholder(text, data) {

    if(typeof text !== "undefined") {
        return text.map(str => {
            data.forEach(item => {
                str = str.replace(`{${item.name}}`, item.values);
            });
            return str;
        });
    }

    return null;
}

function svgToPng(svgContent, callback) {
    const img = new Image();
    const svg = new Blob([svgContent], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(svg);

    img.onload = function() {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const context = canvas.getContext('2d');
        context.drawImage(img, 0, 0);
        URL.revokeObjectURL(url);
        canvas.toBlob(callback, 'image/png');
    };
    img.src = url;
}

function getSvgLabel(a,m,center,rand,svgContent) {

    svgToPng(svgContent, (blob) => {
        var url = URL.createObjectURL(blob);

        m.loadImage(url, (error, image) => {
            if (error) throw error;
            m.addImage('label-'+rand, image);

            // Add a layer with the custom icon
            m.addLayer({
                id: 'xplan:BP_BaugebietsTeilFlaeche_label-'+rand,
                type: 'symbol',
                'minzoom': 18,
                source: {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: [center]
                    }
                },
                layout: {
                    'visibility': 'visible',
                    'icon-allow-overlap': true,
                    'icon-ignore-placement': true,
                    'icon-image': 'label-'+rand,
                    'icon-size': 0.5
                }
            });
        });


    });

    return m;
}

export const getMainStyle = (map, plan, setMap, setLayerCategory) => {

    var mapLables = [];

    const getVisualsBackground = (m,visuals,style,features,id) => {

        // add source
        m.addSource(id+"_"+style, {
            'type': 'geojson',
            'data': {
                "type": "FeatureCollection",
                "name": id+"_"+style,
                "features": features
            }
        });

        // define layer
        var layer = {
            'id': id+"_"+style,
            'type': 'fill',
            'source': id+"_"+style,
            'layout': {
                'visibility': 'visible',
                "fill-sort-key":1,
            },
            'paint': {}
        }

        // set backgroundColor
        if((typeof visuals?.[style]?.backgroundColor !== "undefined" )) {
            layer.paint["fill-color"] = visuals?.[style]?.backgroundColor;
        }

        // set backgroundOpacity
        if((typeof visuals?.[style]?.backgroundOpacity !== "undefined" )) {
            layer.paint["fill-opacity"] = visuals?.[style]?.backgroundOpacity;
        } else if(visuals?.[style]?.backgroundOpacity === 0) {
            layer.paint["fill-opacity"] = visuals?.[style]?.backgroundOpacity;
        } else {
            layer.paint["fill-opacity"] = 0.001;
        }

        m.addLayer(layer);

        return m;
    }

    const getVisualsBackgroundPattern = (m,visuals,style,features,id) => {

        // looks for SVG on assests
        var path =  require('../../assets/icons/'+visuals?.[style]?.icon+'.png');

        if(path) {

            // const svgUrl = 'https://example.com/your-icon.svg';
            // add source
            m.addSource(id+"_"+style+"_pattern", {
                'type': 'geojson',
                'data': {
                    "type": "FeatureCollection",
                    "name": id+"_"+style+"_pattern",
                    "features": features
                }
            });

            var rand = Math.floor(Math.random() * 10000);

            map.loadImage(path, (error, image) => {
                map.addImage(visuals?.[style]?.icon+"-"+rand+"-pattern", image, {
                    sdf: true,  // Whether to use signed distance field for the image
                    pixelRatio: window.devicePixelRatio, // Adjust for device pixel ratio
                    width: 28,  // Specify the width of the pattern
                    height: 28
                });
            });

            // define layer
            var layer = {
                'id': id+"_"+style+"_pattern",
                'type': 'fill',
                'source': id+"_"+style+"_pattern",
                'layout': {
                    'visibility': 'visible',
                    "fill-sort-key":1,
                },
                'paint': {
                    'fill-opacity': 1,
                    'fill-pattern': visuals?.[style]?.icon+"-"+rand+"-pattern"
                }
            }

            m.addLayer(layer);
        }
        return m;
    }

    const getVisualsBorder = (m,visuals,style,features,id) => {

               // add source
        m.addSource(id+"_"+style, {
            'type': 'geojson',
            'data': {
                "type": "FeatureCollection",
                "name": id+"_"+style,
                "features": features
            }
        });

        // define layer
        var layer = {
            'id': id+"_"+style,
            'type': 'line',
            'source': id+"_"+style,
            'layout': {
                'visibility': 'visible',
                'line-sort-key': 1,
            },
            'paint': {},
        }

        // set backgroundColor
        if((typeof visuals?.[style]?.borderColor !== "undefined" )) {
            layer.paint["line-color"] = visuals?.[style]?.borderColor;
        }

        if((typeof visuals?.[style]?.borderSize !== "undefined" )) {
            layer.paint["line-width"] = visuals?.[style]?.borderSize;
        } else {
            layer.paint["line-width"] = 1;
        }

        if((typeof visuals?.[style]?.borderOffset !== "undefined" )) {
            layer.paint["line-offset"] = visuals?.[style]?.borderOffset;
        }

        if((typeof visuals?.[style]?.borderOpacity !== "undefined" )) {
            layer.paint["line-opacity"] = visuals?.[style]?.borderOpacity;
        } else {
            layer.paint["fill-opacity"] = 1;
        }

        if((typeof visuals?.[style]?.borderDashArray !== "undefined" )) {
            layer.paint["line-dasharray"] = visuals?.[style]?.borderDashArray;
        }

        if(id.includes("xplan:BP_FirstRichtungsLinie") === true) {

            var start = [];
            var end = [];

            for (var a of features) {

                start?.push({
                    geometry: {
                        coordinates: a?.geometry?.coordinates?.[0],
                        type:"Point",
                    },
                    type:"Feature",
                    properties:{
                        bearing: ((getBearing(a?.geometry?.coordinates?.[0], a?.geometry?.coordinates?.[1]) + 180) % 360)
                    }
                });

                end?.push({
                    geometry: {
                        coordinates: a?.geometry?.coordinates?.[1],
                        type:"Point",
                    },
                    type:"Feature",
                    properties:{
                        bearing: ((getBearing(a?.geometry?.coordinates?.[0], a?.geometry?.coordinates?.[1]) + 0) % 360)
                    }
                });


            }



            m.addSource(id+"_BP_FirstRichtungsLinie_start", {
                'type': 'geojson',
                'data': {
                    "type": "FeatureCollection",
                    "name": id+"_BP_FirstRichtungsLinie_start",
                    "features": start
                }
            });


            m.addSource(id+"_BP_FirstRichtungsLinie_end", {
                'type': 'geojson',
                'data': {
                    "type": "FeatureCollection",
                    "name": id+"_BP_FirstRichtungsLinie_end",
                    "features": end
                }
            });


            m.addLayer({
                'id': id+"_BP_FirstRichtungsLinie_start",
                'type': 'symbol',
                'minzoom': 14,
                'source': id+"_BP_FirstRichtungsLinie_start",
                'layout': {
                    'icon-image': 'reck3',
                    'visibility': 'visible',
                    'icon-allow-overlap': true,
                    "symbol-placement":"point",
                    'icon-ignore-placement': true,
                    "symbol-sort-key":99999,
                    'icon-rotate': ['get', 'bearing'],
                    'icon-rotation-alignment':'map',
                    'icon-anchor': 'center',
                    'icon-size':1.2
                },
                'paint': {
                    'icon-color': "rgba(0, 0, 0, 0)",
                    "text-color": "#000000",
                    "text-halo-width": 1,

                }
            });

            m.addLayer({
                'id': id+"_BP_FirstRichtungsLinie_end",
                'type': 'symbol',
                'minzoom': 14,
                'source': id+"_BP_FirstRichtungsLinie_end",
                'layout': {
                    'icon-image': 'reck3',
                    'visibility': 'visible',
                    'icon-allow-overlap': true,
                    "symbol-placement":"point",
                    "symbol-sort-key":99999,
                    'icon-rotate': ['get', 'bearing'],
                    'icon-rotation-alignment':'map',
                    'icon-anchor': 'center',
                    'icon-size':1.2
                },
                'paint': {
                    'icon-color': "rgba(0, 0, 0, 0)",
                    "text-color": "#000000",
                    "text-halo-width": 1
                }
            });

        }

        m.addLayer(layer);

        return m;
    }

    const getLineDescriptions = (m,visuals,style,features,id) => {
        // add source
        m.addSource(id+"_"+style, {
            'type': 'geojson',
            'data': {
            "type": "FeatureCollection",
            "name": id+"_"+style,
            "features": features
            }
        });
        m.addLayer({
            'id': id+"_"+style+"_description",
            'type': 'symbol',
            'source': id+"_"+style,
            'layout': {
            "text-field": ['get','description', ['properties']],
            'text-justify': 'auto',
            'text-size': 12,
            "symbol-sort-key":99999,
            'symbol-placement': 'line',
            },
            'paint': {
            "text-color": "#000000",
            'text-halo-color': "#ffffff",
            "text-halo-width": 2
            }
        });
        return m;
    }

    const getPolygonDescriptions = (m,visuals,style,features,id) => {
        // add source
        m.addSource(id+"_"+style, {
            'type': 'geojson',
            'data': {
                "type": "FeatureCollection",
                "name": id+"_"+style,
                "features": features
            }
        });

        m.addLayer({
            'id': id+"_"+style+"_description",
            'type': 'symbol',
            'source': id+"_"+style,
            'layout': {
                "text-field": ['get','description', ['properties']],
                'text-justify': 'auto',
                'text-size': 12,
                "symbol-sort-key":99999,
                'symbol-placement': 'point',
            },
            'paint': {
                "text-color": "#000000",
                'text-halo-color': "#ffffff",
                "text-halo-width": 2
            }
        });
        return m;
    }

    const getPointDescriptions = (m,visuals,style,features,id) => {
        // add source
        m.addSource(id+"_"+style, {
            'type': 'geojson',
            'data': {
                "type": "FeatureCollection",
                "name": id+"_"+style,
                "features": features
            }
        });

        m.addLayer({
            'id': id+"_"+style+"_description",
            'type': 'symbol',
            'source': id+"_"+style,
            'layout': {
                "text-field": ['get','description', ['properties']],
                'text-justify': 'auto',
                'text-size': 12,
                "symbol-sort-key":99999,
                'symbol-placement': 'point',
            },
            'paint': {
                "text-color": "#000000",
                'text-halo-color': "#ffffff",
                "text-halo-width": 2
            }
        });
        return m;
    }

    const getDescriptions = (m,visuals,style,features,id) => {
        const polygonFeatures = features.filter(feature => feature.geometry.type === "Polygon" || feature.geometry.type === "MultiPolygon");
        const lineFeatures = features.filter(feature => feature.geometry.type === "LineString" || feature.geometry.type === "MultiLineString");
        const pointFeatures = features.filter(feature => feature.geometry.type === "Point" || feature.geometry.type === "MultiPoint");
        if (polygonFeatures.length > 0) {
            m = getPolygonDescriptions(m,visuals,style,polygonFeatures,id + "_polygon");
        }
        if (lineFeatures.length > 0) {
            m = getLineDescriptions(m,visuals,style,lineFeatures,id + "_line");
        }
        if (pointFeatures.length > 0) {
            m = getPointDescriptions(m,visuals,style,pointFeatures,id + "_point");
        }
        return m;
    }

    const getVisualsPointIcon = (m,visuals,style,features,id) => {

        // looks for SVG on assests
        var path =  require('../../assets/icons/'+visuals?.[style]?.icon+'.png');
        var newFeature = [];

        for (var h in features) {

            if(features[h]?.geometry?.type === "Polygon"  && visuals?.[style]?.symbolPlacement === "point"){
                const coords = features[h].geometry.coordinates;
                const bestPoint = polylabel(coords, 0.000001);
                const n = turf.point(bestPoint);
                    n.properties.text = replacePlaceholder(visuals?.[style]?.mapLabel,features?.[h].properties?.details)?.[0]?.replace(/\{[^}]*\}/g, '');
                    n.properties = features?.[h].properties;
                newFeature.push(n);
            } else {
                features[h].properties.text = replacePlaceholder(visuals?.[style]?.mapLabel,features?.[h].properties?.details)?.[0]?.replace(/\{[^}]*\}/g, '');
                newFeature.push(features[h]);
            }
        }


        if(path) {

            m.addSource(id+"_"+style+"_icon", {
                'type': 'geojson',
                'data': {
                    "type": "FeatureCollection",
                    "name": id+"_"+style+"_icon",
                    "features": newFeature
                }
            });

            map.loadImage(path, (error, image) => {
                //if (error) throw error;
                map.addImage(visuals?.[style]?.icon+"-"+id+"-file", image); // Name of the image
            });

            // define layer
            var layer = {
                'id': id+"_"+style+"_icon",
                'type': 'symbol',
                'minzoom': 14,
                'source': id+"_"+style+"_icon",
                'layout': {

                    'visibility': 'visible',
                    'icon-allow-overlap': true,
                    'icon-ignore-placement': true,
                    "symbol-sort-key":99999,
                },
                'paint': {
                    'icon-color': "rgba(0, 0, 0, 0)",
                    "text-color": "#000000",
                    "text-halo-width": 1
                }
            }

            layer.layout["icon-image"] = visuals?.[style]?.icon+"-"+id+"-file";

            if(typeof visuals?.[style]?.symbolPlacement !== "undefined") {
                layer.layout["symbol-placement"] = visuals?.[style]?.symbolPlacement;
                layer.layout["symbol-sort-key"] = 999999;
                layer.layout["icon-allow-overlap"] = true;
                layer.layout["icon-rotation-alignment"] = "auto";
                layer.layout["icon-ignore-placement"] = false;
                layer.layout["icon-padding"] = 1;
            } else {
                layer.layout["symbol-placement"] = "point";
                layer.layout["symbol-sort-key"] = 99999999;
                layer.layout["icon-allow-overlap"] = true;
                layer.layout["icon-rotation-alignment"] = "auto";
                layer.layout["icon-ignore-placement"] = false;
                layer.layout["icon-padding"] = 1;
            }

            if((typeof visuals?.[style]?.iconRotate !== "undefined" )) {
                layer.layout["icon-rotate"] = parseInt(visuals?.[style]?.iconRotate);
            } else {
                layer.layout["icon-rotate"] = 0;
            }

            if((typeof visuals?.[style]?.iconSpacing !== "undefined" )) {
                layer.layout["symbol-spacing"] = visuals?.[style]?.iconSpacing;
            } else {
                layer.layout["symbol-spacing"] =  10;
            }

            if((typeof visuals?.[style]?.iconSize !== "undefined" )) {
                layer.layout["icon-size"] = visuals?.[style]?.iconSize;
            } else {
                layer.layout["icon-size"] = 1;
            }

            /*if((typeof visuals?.[style]?.iconAnchor !== "undefined" )) {
                layer.layout["icon-anchor"] = visuals?.[style]?.iconAnchor;
            }*/

            if((typeof visuals?.[style]?.iconOffset !== "undefined" )) {
                layer.layout["icon-offset"] = visuals?.[style]?.iconOffset;
            }

            if((typeof visuals?.[style]?.mapLabel !== "undefined" )) {
                layer.layout["text-field"] = ['get','text', ['properties']];
                layer.layout["text-variable-anchor"] = ['top'];
                layer.layout["text-radial-offset"] = 1.5;
                layer.layout["text-justify"] = 'auto';
                layer.paint["text-halo-width"] = 1;
                layer.layout["text-size"] = 10;
            }

            m.addLayer(layer);

            if(id.includes("BP_BaugebietsTeilFlaeche_") === true && typeof plan?.data?.["xplan:XP_PPO"] === "undefined") {

                var newFeatures = [];
                for (var feature of features ) {

                    var label= "-";

                    for (var detail of feature?.properties?.details) {
                        if(detail?.name === "Gliederung") {
                            label= detail?.values;
                        }
                    }

                    feature.properties.gliederung = label;
                    newFeatures?.push(feature);
                }

                m.addSource(id+"_BP_BaugebietsTeilFlaeche_"+style+"_text", {
                    'type': 'geojson',
                    'data': {
                        "type": "FeatureCollection",
                        "name": id+"_"+style+"_icon",
                        "features": features
                    }
                });

                // define layer
                var layer = {
                    'id': id+"_"+style+"_text1",
                    'type': 'symbol',
                    'source': id+"_"+style+"_icon",
                    'layout': {
                        "symbol-sort-key":99999,
                        'text-size':10,
                        'text-field' : ['coalesce',['get', 'gliederung', ['properties']],"-"],
                        'visibility': 'visible',
                        'text-variable-anchor': ['top'],
                        'text-radial-offset': 0.4,
                        'text-justify': 'auto',
                    },
                    'paint': {}
                }

                m.addLayer(layer);

            }
        }

        return m;
    }

    const getVisualsPointText = (m,visuals,style,features,id) => {

        if((typeof visuals?.[style]?.text !== "undefined" )) {

            var newFeature = [];

            for (var h in features) {
                if(features[h]?.geometry?.type === "Polygon" ){
                    const coords = features[h].geometry.coordinates;
                    const bestPoint = polylabel(coords, 0.000001);
                    const n = turf.point(bestPoint);
                    n.properties = features?.[h].properties;
                    n.properties.iconText = replacePlaceholder(visuals?.[style]?.text,features?.[h].properties?.details)?.[0]?.replace(/\{[^}]*\}/g, '');
                    newFeature.push(n);
                } else {
                    features[h].properties.iconText = replacePlaceholder(visuals?.[style]?.text,features?.[h].properties?.details)?.[0]?.replace(/\{[^}]*\}/g, '');
                    newFeature.push(features[h]);
                }
            }


            // add source
            m.addSource(id+"_"+style, {
                'type': 'geojson',
                'data': {
                    "type": "FeatureCollection",
                    "name": id+"_"+style,
                    "features": newFeature
                }
            });

            // define layer
            var layer = {
                'id': id+"_"+style,
                'type': 'symbol',
                'source': id+"_"+style,
                'minzoom': 14,
                'layout': {
                    "text-field": ['get','iconText', ['properties']],
                    'text-variable-anchor': ['top'],
                    'text-radial-offset': 1.5,
                    'text-justify': 'auto',
                    'text-size': 12,
                    "symbol-sort-key":99999,
                },
                'paint': {
                    "text-color": "#ffffff",
                    "text-halo-width": 1
                }
            }

            if((typeof visuals?.[style]?.textColor !== "undefined" )) {
                layer.paint["text-color"] = visuals?.[style]?.textColor;
            } else {
                layer.paint["text-color"] = '#000'
            }

            if((typeof visuals?.[style]?.textHaloColor !== "undefined" )) {
                layer.paint["text-halo-color"] = visuals?.[style]?.textHaloColor;
            } else {
               // layer.paint["text-halo-color"] = '#000000'
            }

            if((typeof visuals?.[style]?.textHaloWidth !== "undefined" )) {
                layer.paint["text-halo-width"] = visuals?.[style]?.textHaloWidth;
            } else {
                layer.paint["text-halo-width"] = 3
            }

            if((typeof visuals?.[style]?.textSize !== "undefined" )) {
                layer.layout["text-size"] = visuals?.[style]?.textSize;
            } else {
                layer.layout["text-size"] = 12;
            }
        }

        m.addLayer(layer);


        return m;
    }

    const getVisualsLabel = (m,visuals,style,features,id) => {

        let newFeatures = [];

        for (const a of features) {

            const fields = [
                "Gliederung",
                "Gliederung 1",
                "Gliederung 2",
                "Aufschrift",
                "Allgemeine Art der Baulichen Nutzung",
                "Bebauungsart",
                "Bauweise",
                "Dachgestaltung",
                "Nutzung",
                "Max.Anzahl Wohnungen",
                "Maximal zulässige Grundflächenzahl",
                "Maximal zulässige Geschossflächenzahl",
                "Maximal zulässige Geschossfläche",
                "Maximal zulässige Zahl an Vollgeschossen",
                "Maximal zulässige Höhe",
                "Bestimmung der Höhenangaben",
                "Art des Höhenbezuges"];
            let lables = "";
            let y = 520;
            const valueHeight = 50;
            const details = a.properties?.details;

            const filteredDetails = details.filter((detail) => fields.includes(detail.name));

            for (const b in filteredDetails ) {
                let values = filteredDetails[b].values;
                let name = filteredDetails[b].name;    

                if (typeof values === 'string') {
                    values =  values.split("\n")
                    // remove all trailing empty values
                    while (values.length > 0 && values[values.length - 1] === "") {
                        values.pop();
                    }

                } else {
                    values = [values];
                }

                if (name.length > 37) {
                    name = name.substring(0, 36) + "...";
                }
                
                lables = `${lables}<text width="400" x="30" y="${y+40}" font-size="40" stroke-width="0" fill="#777" stroke="#777" font-weight="lighter" style="font-family: 'Helvetica', sans-serif" text-anchor="left" dominant-baseline="middle">${name}</text>`
                for (const i in values) {
                    let value = values[i];
                    if (value.length > 36) {
                        value = value.substring(0, 35) + "...";
                    }
                    lables = `${lables}<text width="400" x="30" y="${y + i * valueHeight + 90}" font-size="40" stroke-width="1" fill="#222" stroke="#222" font-weight="normal" style="font-family: 'Helvetica', sans-serif" text-anchor="left" dominant-baseline="middle">${value}</text>`
                }

                y = y + values.length * valueHeight + 70;
                console.log('b', b, filteredDetails.length, parseInt(b), filteredDetails.length - 1);
                if (filteredDetails.length > 1 && parseInt(b) < filteredDetails.length - 1) {
                    lables = `${lables}<line x1="20" y1="${y}" x2="760" y2="${y}" stroke="#555" stroke-width="2"></line>`
                }
            }


            const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs" viewBox="0 0 800 800" opacity="1" width="450" height="1800">
                                            <g stroke-width="2" fill="#ffffffee" stroke="hsla(0, 0%, 0%, 1.00)" >
                                            <rect width="800" stroke-width="3" height="${y - 520}" x="0" y="520"  stroke="#000" rx="20"></rect>  <!-- background -->
                                            ${lables}
                                            </g>
                                       </svg>`;

            const coords = a.geometry.coordinates;
            const bestPoint = polylabel(coords, 0.000001);
            const center = turf.point(bestPoint);
            const rand = Math.floor(Math.random() * 1000000);

            newFeatures.push(center);

            m = getSvgLabel(a,m,center,rand,svgContent);

            mapLables.push('xplan:BP_BaugebietsTeilFlaeche_label-'+rand);
        }


        console.log("-----------");
        console.log(features);
        console.log(newFeatures);

        m = getVisualsPointIcon(m, visuals,"overlayIcon", newFeatures, id);

        return m;

    }

    const getPolygon = (m, visuals, features, id) => {

        let hasDescription = false;
        for (const h in features) {
            for (const j in features[h]?.properties?.details) {
                if(features[h].properties.details[j]?.name === "Aufschrift") {
                    hasDescription = true;
                    features[h].properties.description = features[h].properties.details[j].values;
                }
            }
        }

        if(typeof visuals?.baseBackground !== "undefined") {
            m = getVisualsBackground(m, visuals,"baseBackground", features, id);
        }

        if(typeof visuals?.baseBackgroundPattern !== "undefined" && typeof visuals?.baseBackgroundPattern?.icon !== "undefined") {
            m = getVisualsBackgroundPattern(m, visuals,"baseBackgroundPattern", features, id);
        }

        if(typeof visuals?.baseBorder !== "undefined") {
            m = getVisualsBorder(m, visuals,"baseBorder", features, id);
        }

        if(typeof visuals?.overlayBackground !== "undefined") {
            m = getVisualsBackground(m, visuals,"overlayBackground", features, id);
        }

        if(typeof visuals?.overlayBorder !== "undefined") {
            m = getVisualsBorder(m, visuals,"overlayBorder", features, id);
        }

        if (!visuals?.baseBackgroundPattern && !visuals?.baseBackground && !visuals?.overlayBackground) {
            m = getVisualsBackground(m, visuals,"baseBackground", features, id);
        }




        if(id.includes("BP_BaugebietsTeilFlaeche") === true) {
            m = getVisualsLabel(m, visuals,"icon", features, id);
        } else {

            if(typeof visuals?.basesIcon !== "undefined") {
                m = getVisualsPointIcon(m, visuals,"basesIcon", features, id);
            }

            if(typeof visuals?.overlayIcon !== "undefined") {
                m = getVisualsPointIcon(m, visuals,"overlayIcon", features, id);
            }
        }

        if (hasDescription === true) {
            m = getDescriptions(m, visuals,"description", features.filter((feature) => feature.properties.description !== null || typeof feature.properties.description !== 'undefined'), id);
        }

        // TODO: not ready yet. Needs more time and insides from Jakub.
        // if(id.includes("BP_BaugebietsTeilFlaeche") === true) {
        //     m = getVisualsLabel(m, visuals,"icon", features, id);
        // }

        return m;
    };

    const getLineString = (m, visuals, features, id) => {

        let hasDescription = false;
        for (const h in features) {
            for (const j in features[h]?.properties?.details) {
                if(features[h].properties.details[j]?.name === "Aufschrift") {
                    hasDescription = true;
                    features[h].properties.description = features[h].properties.details[j].values;
                }
            }
        }

        if(typeof visuals?.baseBorder !== "undefined") {
            m = getVisualsBorder(m, visuals,"baseBorder", features, id);
        }

        if(typeof visuals?.overlayBorder !== "undefined") {
            m = getVisualsBorder(m, visuals,"overlayBorder", features, id);
        }

        if(typeof visuals?.basesIcon !== "undefined") {
            m = getVisualsPointIcon(m, visuals,"basesIcon", features, id);
        }

        if(typeof visuals?.overlayIcon !== "undefined") {
            m = getVisualsPointIcon(m, visuals,"overlayIcon", features, id);
        }

        if (hasDescription === true) {
            m = getDescriptions(m, visuals,"description", features.filter((feature) => feature.properties.description !== null || typeof feature.properties.description !== 'undefined'), id);
        }

        return m;
    };

    const getPoint = (m, visuals, features, id) => {

        let hasDescription = false;
        for (const h in features) {
            for (const j in features[h]?.properties?.details) {
                if(features[h].properties.details[j]?.name === "Aufschrift") {
                    hasDescription = true;
                    features[h].properties.description = features[h].properties.details[j].values;
                }
            }
        }

        if(typeof visuals?.basesText !== "undefined") {
           // m = getVisualsPointText(m, visuals,"basesText", features, id);
        }

        if(typeof visuals?.basesIcon !== "undefined") {
            m = getVisualsPointIcon(m, visuals,"basesIcon", features, id);
        }


        if(typeof visuals?.overlayText !== "undefined") {
           // m = getVisualsPointText(m, visuals,"overlayText", features, id);
        }


        if(typeof visuals?.overlayIcon !== "undefined") {
            m = getVisualsPointIcon(m, visuals,"overlayIcon", features, id);
        }

        if (hasDescription === true) {
            m = getDescriptions(m, visuals,"description", features.filter((feature) => feature.properties.description !== null || typeof feature.properties.description !== 'undefined'), id);
        }

        return m;
    };

    const getVisualisations = (m, xplanLayerDatasets, id) => {

        // center the map
        if(
            id.includes("xplan:BP_Plan") === true
            || id.includes("xplan:FP_Plan") === true
            || id.includes("xplan:LP_Plan") === true
            || id.includes("xplan:RP_Plan") === true
        ) {
            var bbox = turf.bbox(xplanLayerDatasets?.features?.[0]?.geometry);
            m.fitBounds(bbox, {
                padding: {top: 100, bottom:50, left: 50, right: 50},
                duration: 0
            });
        }

        if( xplanLayerDatasets?.type === "Polygon" || xplanLayerDatasets?.type === "MultiPolygon") {
            return getPolygon(m, xplanLayerDatasets?.visualisation, xplanLayerDatasets?.features, id);
        } else if( xplanLayerDatasets?.type === "LineString" || xplanLayerDatasets?.type === "MultiLineString") {
            return getLineString(m, xplanLayerDatasets?.visualisation, xplanLayerDatasets?.features, id);
        } else if( xplanLayerDatasets?.type === "Point") {
            return getPoint(m, xplanLayerDatasets?.visualisation, xplanLayerDatasets?.features, id);
        }

    }

    for (const [xplanLayer] of Object.entries(plan.data)) {

        for (const [xplanLayerDatasets] of Object.entries(plan.data?.[xplanLayer]?.datasets)) {
            var id = xplanLayer+"_"+plan.data?.[xplanLayer]?.datasets?.[xplanLayerDatasets]?.sorting;

            var visu = getVisualisations(map, plan.data?.[xplanLayer]?.datasets?.[xplanLayerDatasets],id)

            if(typeof visu !== "undefined") {
                setMap(visu);
            }

            // create Category
            const layers = map?.getStyle().layers;

            if(typeof layers !== "undefined") {
                var category = {};

                for(var l in layers) {

                    var layer = layers[l]?.source;

                    if(typeof layer !== "undefined" && typeof layer?.split("_")[0] !== "undefined" && typeof layer?.split("_")[1] !== "undefined" && layer !== "composite") {

                        if (typeof category[layer?.split("_")[0]+"_"+layer?.split("_")[1]] === "undefined") {
                            category[layer?.split("_")[0]+"_"+layer?.split("_")[1]] = {
                                layerIds:[],
                                visible:true,
                                name: (typeof plan?.["data"]?.[(layer?.split("_")[0]+"_"+layer?.split("_")[1])]?.["name"] !== "undefined") && plan?.["data"]?.[(layer?.split("_")[0]+"_"+layer?.split("_")[1])]?.["name"],
                            }
                        }
                        category[layer?.split("_")[0]+"_"+layer?.split("_")[1]]["layerIds"].push(layer);

                        if (layer.includes("icon") === true) {
                            map.moveLayer(layer, layers[layers.length - 1].id);  // Moves before the last layer
                        }

                    }

                    setLayerCategory(category);
                }
            }

            if(mapLables?.length > 1 && typeof category !== "undefined") {

                category["aufschriften"] = {
                    layerIds:mapLables,
                    visible:true,
                    name: "Aufschrift",
                }

                setLayerCategory(category);
            }
        }
    }

    return;
}

export const get3dStyle = (m, review, mapUrl) => {

    if(typeof mapUrl !== "undefined") {

        // Add WMS Source
        if (!m.getSource('wms-source')) {
            m.addSource('wms-source', {
                'type': 'raster',
                'tiles': [mapUrl?.url],
                'tileSize': mapUrl?.size
            });
        }

        m.addLayer({
            'id': 'wms-layer',
            'type': 'raster',
            'source': 'wms-source',
            'paint': {}
        }, 'continent-label');

    }

    m.addLayer({
        'id': '3d-buildings',
        'source': 'composite',
        'source-layer': 'building',
        'type': 'fill-extrusion',
        'minzoom': 17,
        'layout': {
            'visibility': 'none'
        },
        'paint': {
            'fill-extrusion-color': '#c8c8c8',
            'fill-extrusion-height': [
                'interpolate',
                ['linear'],
                ['zoom'],
                15,
                0,
                15.05,
                ['get', 'height']
            ],
            'fill-extrusion-base': [
                'interpolate',
                ['linear'],
                ['zoom'],
                15,
                0,
                15.05,
                ['get', 'min_height']
            ],
            'fill-extrusion-opacity': 1
        }
    });

    var t = [];

    Object.keys(review).forEach(key => {

        var x = {};
        x = {...review[key]?.location};
        x["properties"] = review[key];
        x["id"] = key;
        t.push(x)
    });

    if (!m.getSource("review")) {
        m.addSource("review", {
            'type': 'geojson',
            'data': {
                "type": "FeatureCollection",
                "name": "review",
                "features": t
            }
        });
    }

    m.addLayer({
        'id': "gl-draw-point-active.hot",
        'type': 'circle',
        'source': "review",
        'layout': {},
        'paint': {
            "circle-radius":       20,
            'circle-color': [
                'case',
                ['==', ['get', 'status'], 'done'], '#50b43c',
                '#D22828' // default color if no match
            ],
            "circle-opacity":      1,
            "circle-stroke-width": 2,
            'circle-stroke-color': "#ffffff"
        }
    });

    m.addLayer({
        'id': "gl-draw-point-active.hot.icon",
        'type': 'symbol',
        'source': "review",
        'layout': {
            'icon-image': [
                'case',
                ['==', ['get', 'type'], 'error'], 'icon-error', // icon for active
                ['==', ['get', 'type'], 'question'], 'icon-question', // icon for off
                ['==', ['get', 'type'], 'reminder'], 'icon-reminder', // icon for info
                ['==', ['get', 'type'], 'request'], 'icon-request', // icon for info
                ['==', ['get', 'type'], 'additional'], 'icon-additional', // icon for info
                'default-icon' // default icon if no match
            ],
            'icon-size': 1.5, // adjust as needed
            'icon-allow-overlap': true
        }
    });

}